/**
 * The below file is the Origin Area service which contains method for doing the API calls.
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import fetch from "auth/FetchInterceptor";
import {
  Application_Json,
  Authorization_Token,
  Get_All_Origin_Area,
} from "constants/ApiConstant";
import { format } from "react-string-format";
import { AUTH_TOKEN } from "redux/constants/Auth";

const OriginAreaService = {};

//#region Method for Origin Area dropdown

/**
 * Method for getting the Origin Area dropdown
 * @param {any} param API Parameters
 * @returns Fetch Method
 */
OriginAreaService.getAllOriginArea = function () {
  return fetch({
    url: Get_All_Origin_Area,
    method: "get",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
  });
};

//#endregion Method for Origin Area dropdown.

export default OriginAreaService;
